import { Component, ElementRef, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { PaginationService } from 'src/app/PaginationService';
import { AppService } from 'src/app/app.service';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { EditorComponent } from 'src/app/editor/editor.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';
import { messageService } from 'src/app/message.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { PopupData } from 'src/app/users/users.component';

@Component({
  selector: 'app-form-section-template',
  templateUrl: './form-section-template.component.html',
  styleUrls: ['./form-section-template.component.scss']
})
export class FormSectionTemplateComponent implements OnInit {

  @Input() data: any;
  isProcessing = true;
  _temp: any = {};
  columnLists: any = {};
  formSectionTemplateList: any = [];
  formSectionTemplateListTemp: any = [];
  formSectionTemplateData: any;
  makeStickyColumns: any;
  dataTypeList: any = [];
  fieldsPerLinesearchTxt: string = '';
  constructor(public dialog: MatDialog, private appService: AppService, public router: Router, private snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService, private elem: ElementRef) { }

  visibleDataGrid: boolean = false;
  itemsPerPage = 5; // Number of items to display per page
  currentPage = 1; // Current page number
  totalPages = 0; // Total number of pages
  fieldsPerLineDropdown = [1, 2, 3, 4]

  //page = 1;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;

  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  private users: any[];
  pager: any = {};
  pagedItems: any[];
  error = '';
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.formSectionTemplateList.length, page, this.perPage, targetpage);
    this.pagedItems = this.formSectionTemplateList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  @ViewChild
    (EditorComponent) editorComponent!: EditorComponent;
  getClobData(list: any, colunName: any) {
    //this.visibleviwerClobPopup = this.dialog.open(this.viwerClobPopup, this.aviwerlPopupConfig);
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: colunName
    }
    this.htmlContent = "";
    this.appService.getClobToViewAudit(docObj).subscribe((Response: any) => {
      console.log(Response.result);
      this.htmlContent = Response.result;
      this.editorComponent.openEditor(this.htmlContent, colunName);
    }, (error) => {
      console.log(error);

    })
    this.isProcessing = false;

  }
  htmlContent: any;
  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  setPagedorserch(page: number, targetpage: number) {
    // if (page < 1 || page > this.pager.totalPages) {
    //   return;
    // }
    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.formSectionTemplateListTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.formSectionTemplateListTemp.length, page, this.perPage, targetpage);
      this.pagedItems = this.formSectionTemplateListTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  getcallMethod() {
    this.isProcessing = true;
    this.formSectionTemplateList = [];
    const data = {

      gridName: "FORM_SECTION_TEMPLATE"
    }
    this.appService.getDynamicGridHeaders(data).subscribe((response: any) => {

      if (response.orderByClause == null) {
        response.orderByClause = "";
      }

      this.makeStickyColumns = response.fixedFieldCnt;

      const data1: any = {

        gridName: "ONEQMS_FORM_SECTION_TEMPLATE_VW",
        tableOrViewName: response.tableOrViewName == null ? "" : response.tableOrViewName,
        columnsList: response.columnsList == null ? "" : response.columnsList,
        fieldLabelsList: response.fieldLabelsList == null ? "" : response.fieldLabelsList,
        invisibleColumn: response.invisibleColumn == null ? "" : response.invisibleColumn,
        orderByClause: response.orderByClause == null ? "" : response.orderByClause,
        fieldSizeList: response.fieldSizeList == null ? "" : response.fieldSizeList,
        columnsListarray: [],
        fieldColumnarray: [],
        invisibleColumnarray: [],
        fieldSizeListArray: [],
        templateIdFromQmsReportTemplate: this.data.templateId,
        manualEntryDataFields: response.manualEntryDataFields,
        clobColumnlist: response.closblist || "",
        blobColumnlist: response.bloblist || ""
      }
      this.reportObj = { ...data1, ...data };
      this.appService.getDynamicGridData(data1).subscribe((response1: any) => {
        this.formSectionTemplateList = response1;
        console.log('Data - ', this.formSectionTemplateList);
        data1.columnsListarray = data1.columnsList.split(",");
        data1.fieldColumnarray = data1.fieldLabelsList.split(",");
        data1.invisibleColumnarray = data1.invisibleColumn.split(",");
        data1.fieldSizeListArray = data1.fieldSizeList.split(",");
        let rendereddata: any;

        /* for(let i=0;i<response1.length;i++){
          this._temp={};
          for(let j=0;j<data1.columnsListarray.length;j++){
            let columnname=data1.columnsListarray[j];
            this._temp[columnname] = response1[i][j];
          }
          this.trainingParameterTemplateDataForGrid.push(this._temp);
        } */

        this.columnLists.columnsListarray = data1.columnsListarray;
        this.columnLists.fieldLabelsList = data1.fieldLabelsList;
        this.columnLists.fieldColumnarray = [];
        for (let p = 0; p < data1.fieldColumnarray.length; p++) {
          this.columnLists.fieldColumnarray.push({
            "fieldColumnarray": data1.fieldColumnarray[p],
            "width": data1.fieldSizeListArray[p] + 'px'
          })
        }
        this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
        this.columnLists.fieldSizeListArray = [];
        for (let w = 0; w < data1.fieldSizeListArray.length; w++) {
          this.columnLists.fieldSizeListArray.push(data1.fieldSizeListArray[w] + 'px');
        }

        for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
          for (let k = 0; k < this.columnLists.invisibleColumnarray.length; k++) {
            if (this.columnLists.columnsListarray[y] == this.columnLists.invisibleColumnarray[k]) {
              this.columnLists.columnsListarray.splice(y, 1);
              this.columnLists.fieldColumnarray.splice(y, 1);
              this.columnLists.fieldSizeListArray.splice(y, 1);
            }
          }
        }

        let tableData = {
          tablename: data1.tableOrViewName
        };
        this.columnLists.columnsListarray1 = [];
        this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
          //console.log(response2);
          this.dataTypeList = response2;
          for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
            this.columnLists.columnsListarray1.push({});
            this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
            this.columnLists.columnsListarray1[m].dataType = "textbox";
            this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
            for (let w = 0; w < this.dataTypeList.length; w++) {
              if (this.dataTypeList[w].columnName == this.columnLists.columnsListarray[m]) {
                this.columnLists.columnsListarray1[m].dataType = this.dataTypeList[w].fieldType;
              }
            }
          }
          //console.log(this.columnLists.columnsListarray1);
          for (let i = 0; i < this.formSectionTemplateList.length; i++) {
            for (let y = 0; y < this.dataTypeList.length; y++) {
              if (this.dataTypeList[y].fieldType == 'CHECKBOX') {
                this.formSectionTemplateList[i][this.dataTypeList[y].columnName] = this.formSectionTemplateList[i][this.dataTypeList[y].columnName] == "Y" ? true : false;
              }
            }

          }
          //this.trainingParameterTemplateDataForGrid=this.trainingParameterTemplateDataForGrid;
          this.calculateTotalPages = this.collectionSize / this.perPage;
          //console.log(this.trainingParameterTemplateDataForGrid);
          this.setPage(1, 0);
          this.pager.totalPages = undefined;
          this.labelcall();
        });
        this.message.gridList = this.formSectionTemplateList;
        this.collectionSize = this.formSectionTemplateList.length;
        this.totalPages = Math.ceil(this.formSectionTemplateList.length / this.itemsPerPage);

        //this.updateDisplayedData();
      }, (error) => {
        this.isProcessing = false;
        throw error;
      });
      this.isProcessing = false;
    }, (error) => {
      this.isProcessing = false;
      throw error;
    });

  }

  label: any = [];
  dynamicLabel: any = null;
  labelcall() {
    this.isProcessing = true;
    let data = {
      tableName: this.reportObj.tableOrViewName,
      moduleName: null,
      gridName: this.reportObj.gridName,
      groupId: 0
    };
    this.appService.getreorderGirdColumnList(data).subscribe((data: any) => {
      this.label = data;
      this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
        acc[`${user.columnName}`] = user.changedFieldName;
        return acc;
      }, {});
      console.log(this.dynamicLabel);
      this.isProcessing = false;
      //this.label = data;
    }, (error: any) => {
      this.isProcessing = false;
    });
  }
  ngOnInit() {


  }

  templateDropdown: any = [];
  ngOnChanges() {
    this.isProcessing = true;
    this.appService.getFormTemplateList()
      .subscribe((data: any) => {
        this.isProcessing = false;
        this.templateDropdown = data;
      })
    this.getcallMethod();
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();

    if (filter === '') {
      this.pagedItems = this.formSectionTemplateList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.formSectionTemplateList.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)

      );
    }
  }

  searchValue: any;
  searchValue2: any;
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.formSectionTemplateListTemp = this.formSectionTemplateList;
      this.pager = this.paginationService.getPager(this.formSectionTemplateListTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.formSectionTemplateListTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      /* this.trainingParameterTemplateDataForGridTemp = this.trainingParameterTemplateDataForGrid.filter((item: { subject: string; date: { toString: () => string | string[]; }; }) =>
        item.subject?.toLowerCase().includes(filter) ||
        item.date?.toString().includes(filter)
      ); */
      if (this.formSectionTemplateList == undefined) {
        return this.formSectionTemplateList;
      }
      if (!this.formSectionTemplateList.length) {
        return this.formSectionTemplateList;
      }
      if (filter != undefined) {
        this.formSectionTemplateListTemp = this.formSectionTemplateList.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });
        //this.totalPages = Math.ceil(this.trainingParameterTemplateDataForGridTemp.length / this.itemsPerPage);
        //this.pager.totalPages=this.totalPages ;

      } else {
        this.formSectionTemplateListTemp = this.formSectionTemplateList.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
        //this.totalPages = Math.ceil(this.trainingParameterTemplateDataForGridTemp.length / this.itemsPerPage);
        //this.pager.totalPages=this.totalPages ;
      }
      this.setPagedorserch(1, 0);
    }
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.formSectionTemplateList.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column as string;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA! < valueB!) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA! > valueB!) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    //let stickycount = 4;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            let previousColumn = elements1[key - 1];
            //console.log(previousColumn.style.offsetWidth);
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }

      index1++;
    })


    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          let keyValue = p / 2;
          column.style.background = keyValue == Math.floor(keyValue) ? 'white' : 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          //column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }

    })
  }


  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;

  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked == true) {
      this.childCheckBoxs = true;
      for (let p = 0; p < this.formSectionTemplateList.length; p++) {
        this.formSectionTemplateList[p].childCheckBoxs = true;
      }

    } else {
      this.childCheckBoxs = false;
      for (let p = 0; p < this.formSectionTemplateList.length; p++) {
        this.formSectionTemplateList[p].childCheckBoxs = false;
      }
    }
  }

  priviousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.priviousSelectedValue != undefined) {
        this.formSectionTemplateList[this.priviousSelectedValue].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
    } else {
      list.childCheckBoxs = false;
    }
    this.priviousSelectedValue = idx;
  }

  validateNoOfDigitsFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '+', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  sectionName: any;
  copySectionFrom: any;
  sectionNameRequiredMsg: any;
  copySectionFromRequiredMsg: any;
  updateRequired: any;
  updateRequiredMsg: any;
  recordLabel: any;
  recordlabelReqMsg: any;


  fieldValidation() {
    this.sectionName = document.getElementById('sectionName') as HTMLInputElement;
    this.sectionNameRequiredMsg = document.getElementById('sectionName-required-msg') as HTMLInputElement;

    this.recordLabel = document.getElementById('addRecordLabel') as HTMLInputElement;
    this.recordlabelReqMsg = document.getElementById('recordlabel-required-msg') as HTMLInputElement;

    this.updateRequired = document.getElementById('udpateReq') as HTMLInputElement;
    this.updateRequiredMsg = document.getElementById('update-reason-required-msg') as HTMLInputElement;

    if (this.formSectionTemplateData.sectionName == "") {
      this.sectionName.style.border = '1px solid red';
      this.sectionNameRequiredMsg.style.display = 'block';
    } else {
      this.sectionName.style.border = 'none';
      this.sectionNameRequiredMsg.style.display = 'none';
    }
    if (this.visibleEditButton) {
      if (!this.formSectionTemplateData.updateReason) {
        this.updateRequired.style.border = '1px solid red';
        this.updateRequiredMsg.style.display = 'block';
      } else {
        this.updateRequired.style.border = 'none';
        this.updateRequiredMsg.style.display = 'none';
      }
    }

   if (!this.formSectionTemplateData.addRecordLabel || this.formSectionTemplateData.addRecordLabel.toString().trim() === "") { 
      this.recordLabel.style.border = '1px solid red';
      this.recordlabelReqMsg.style.display = 'block';
    } else {
      this.recordLabel.style.border = 'none';
      this.recordlabelReqMsg.style.display = 'none';
    }
    if (this.visibleEditButton) {
      if (!this.formSectionTemplateData.updateReason) {
        this.updateRequired.style.border = '1px solid red';
        this.updateRequiredMsg.style.display = 'block';
      } else {
        this.updateRequired.style.border = 'none';
        this.updateRequiredMsg.style.display = 'none';
      }
    }

    if (this.visibleAddButton) {
      if (this.formSectionTemplateData.copyFromTemplateId != null && this.formSectionTemplateData.copyFromTemplateId != '') {
        this.copySectionFrom = document.getElementById('copySectionForm') as HTMLInputElement;
        this.copySectionFromRequiredMsg = document.getElementById('copySectionForm-required-msg') as HTMLInputElement;

        if (this.formSectionTemplateData.copyFromTemplateSectionId == "" || this.formSectionTemplateData.copyFromTemplateSectionId == null) {
          this.copySectionFrom.style.border = '1px solid red';
          this.copySectionFromRequiredMsg.style.display = 'block';
        } else {
          this.copySectionFrom.style.border = 'none';
          this.copySectionFromRequiredMsg.style.display = 'none';
        }
      }
    }
  }

  onFieldFocusout() {
    if (this.sectionNameRequiredMsg != undefined) {
      this.sectionName.style.border = 'none';
      this.sectionNameRequiredMsg.style.display = 'none';
    }

    if (this.deleteFiledValueRequiredMsg != undefined) {
      this.deleteFiledValue.style.border = 'none';
      this.deleteFiledValueRequiredMsg.style.display = 'none';
    }
  }


  operationFlag: any;
  popupDataTitle: PopupData = {
    title: ''
  };

  popupTitle: string | null = 'title';
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  @ViewChild('deleteConfirmationPopup', { static: true }) deleteConfirmationPopup: TemplateRef<any>;
  @ViewChild('fieldPopup', { static: true }) fieldPopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;
  visibleDeleteConfirmationPopup: MatDialogRef<TemplateRef<any>>;
  visibleFieldPopup: MatDialogRef<TemplateRef<any>>;
  addAndEditPopupConfig = {
    width: '700px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  fieldPopupConfig = {
    width: '100%',
    minHeight: '50vh',
    maxHeight: '80vh',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  confirmationDeletePopupConfig = {
    width: '700px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  multipleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
  };

  visibleAddButton: boolean;
  visibleEditButton: boolean;
  visibleReasonForUpdateField: boolean;
  openAddPopup() {
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.visibleReasonForUpdateField = false;
    this.operationFlag = 'ADD';
    this.popupDataTitle.title = "Create Form Section";
    this.formSectionTemplateData = {};
    this.formSectionTemplateData.sectionName = '';
    this.formSectionTemplateData.fieldsPerLine = null;
    this.formSectionTemplateData.addRecordLabel = null;
    this.formSectionTemplateData.header = null;
    this.formSectionTemplateData.verificationReqd1 = false;
    this.formSectionTemplateData.withdrawalReqd1 = false;

    this.formSectionTemplateData.instructions = null;
    this.formSectionTemplateData.copyFromTemplateId = null;
    this.formSectionTemplateData.copyFromTemplateSectionId = null;
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  previousData: any;
  positionValue: any = 1;
  filteredStages: any = [];
  openEditPopup(editRowData: any, editFlag: boolean) {
    this.isProcessing = true;
    this.previousData = editRowData;
    this.visibleReasonForUpdateField = true;
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.operationFlag = 'EDIT';
    this.popupDataTitle.title = "Update Form Section"
    this.appService.getFormSectionTemplateById(this.data.templateId, editRowData.SECTION_ID).subscribe((response: any) => {

      this.formSectionTemplateData = response[0];
      this.formSectionTemplateData.updateReason = '';
      this.formSectionTemplateData.verificationReqd1 = this.formSectionTemplateData.verificationReqd == "Y" ? true : false;
      this.formSectionTemplateData.withdrawalReqd1 = this.formSectionTemplateData.withdrawalReqd == "Y" ? true : false;
      console.log("  this.formSectionTemplateData.withdrawalReqd1 ===", this.formSectionTemplateData.withdrawalReqd1);
      this.isProcessing = false;
    })
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  refreshGridData() {
    this.getcallMethod();
  }

  addAndEditFunction(formSectionTemplateData: any) {
    this.isProcessing = true;
        const isRecordLabelEmpty = !formSectionTemplateData.addRecordLabel || formSectionTemplateData.addRecordLabel.toString().trim() === "";

    if (formSectionTemplateData.sectionName == "" || isRecordLabelEmpty|| (this.visibleEditButton && !formSectionTemplateData.updateReason) || (this.visibleAddButton && (formSectionTemplateData.copyFromTemplateId != '' && formSectionTemplateData.copyFromTemplateId != null) && (formSectionTemplateData.copyFromTemplateSectionId == '' || formSectionTemplateData.copyFromTemplateSectionId == null))) {
      this.fieldValidation();
      this.isProcessing = false;
    } else {
      if (this.operationFlag == 'ADD') {

        formSectionTemplateData.templateId = this.data.templateId;
        formSectionTemplateData.verificationReqd = formSectionTemplateData.verificationReqd1 ? "Y" : "N";
        formSectionTemplateData.withdrawalReqd = formSectionTemplateData.withdrawalReqd1 ? "Y" : "N";

        this.appService.createFormSectionTemplate(formSectionTemplateData).subscribe((Response: any) => {
          if (Response.resultType == "S") {
            this.getcallMethod();
            this.visibleAddAndEditPopup.close();
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok",
              pageName: this.message.breadcrumbData.thirdLevel == null ? this.message.breadcrumbData.secondLevel : this.message.breadcrumbData.thirdLevel
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, (error) => {
          this.isProcessing = false;
          throw error;
        });
      } else {
        delete formSectionTemplateData.createdOn;
        delete formSectionTemplateData.updatedOn;


        formSectionTemplateData.verificationReqd = formSectionTemplateData.verificationReqd1 ? "Y" : "N";
        formSectionTemplateData.withdrawalReqd = formSectionTemplateData.withdrawalReqd1 ? "Y" : "N";

        this.appService.updateFormSectionTemplate(formSectionTemplateData).subscribe((Response: any) => {
          if (Response.resultType == 'S') {
            this.getcallMethod();
            this.visibleAddAndEditPopup.close();
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok",
              pageName: this.message.breadcrumbData.thirdLevel == null ? this.message.breadcrumbData.secondLevel : this.message.breadcrumbData.thirdLevel
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = true;
        }, (error) => {
          this.isProcessing = false;
          throw error;
        });

      }
    }
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }

  deleteFiledValueRequiredMsg: any;
  deleteValidation() {
    this.deleteFiledValueRequiredMsg = document.getElementById('deleteTextarea-required-msg') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.isProcessing = false;
      this.deleteFiledValue.style.border = '1px solid red';
      this.deleteFiledValueRequiredMsg.style.display = 'block';
    } else {
      this.deleteFiledValue.style.border = 'none';
      this.deleteFiledValueRequiredMsg.style.display = 'none';
    }
  }

  deleteFormSectionTemplateTemplateId: any;
  fieldsCount: number;
  deleteList: {};
  openDeletePopup(deleteRowData: any) {
    this.isProcessing = true;
    this.appService.getActiveFormFields(this.data.templateId, deleteRowData.SECTION_ID).subscribe({
      next: (response: any) => {
        if (response.length) {
          this.fieldsCount = response.length;
          this.deleteList = deleteRowData;
          this.visibleDeleteConfirmationPopup = this.dialog.open(this.deleteConfirmationPopup, this.confirmationDeletePopupConfig);
          this.isProcessing = false;
        } else {
          this.isProcessing = false;
          this.formSectionTemplateData = deleteRowData;
          this.operationFlag = 'DELETE';
          this.popupDataTitle.title = "Delete Form Section ";
          this.deleteFormSectionTemplateTemplateId = deleteRowData.SECTION_ID;
          if (this.formSectionTemplateData.deleteReason != undefined) {
            this.formSectionTemplateData.deleteReason = '';
          }
          this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
        }
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    })
  }

  cancelDeleteConfirmation() {
    this.visibleDeleteConfirmationPopup.close();
  }

  proceedDelete(deleteList: any) {
    this.visibleDeleteConfirmationPopup.close();
    this.formSectionTemplateData = deleteList;
    this.operationFlag = 'DELETE';
    this.popupDataTitle.title = "Delete Form Section ";
    this.deleteFormSectionTemplateTemplateId = deleteList.SECTION_ID;
    if (this.formSectionTemplateData.deleteReason != undefined) {
      this.formSectionTemplateData.deleteReason = '';
    }
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  deleteFormTemplateData: any;
  deleteFiledValue: any;
  deleteFunction() {
    this.isProcessing = true;
    this.deleteFiledValue = document.getElementById('deleteTextarea') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.deleteValidation();
      this.isProcessing = false;
    } else {
      let data = {

        templateId: this.data.templateId,
        sectionId: this.deleteFormSectionTemplateTemplateId,
        deleteReason: this.formSectionTemplateData.deleteReason
      }
      this.appService.deleteFormSectionTemplate(data).subscribe((Response: any) => {
        if (Response.resultType == 'S') {
          this.getcallMethod();
          this.visibleDeletePopup.close();
        }
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: Response.result,
            type: Response.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });

      }, (error) => {
        this.isProcessing = false;
        throw error;
      });
    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }



  openFormTemplateFields(list: any) {
    this.formSectionTemplateData = list;
    this.formSectionTemplateData['saveButtonForTemplate'] = this.data.saveButtonForTemplate;
    this.isProcessing = true;
    this.appService.getFormSectionTemplateById(this.data.templateId, list.SECTION_ID).subscribe((response: any) => {
      this.formSectionTemplateData = response[0];
      this.isProcessing = false;
      this.formSectionTemplateData['saveButtonForTemplate'] = this.data.saveButtonForTemplate;
      this.formSectionTemplateData['status'] = this.data.status;
      this.formSectionTemplateData['isFrom'] = "Section";
      this.visibleFieldPopup = this.dialog.open(this.fieldPopup, this.fieldPopupConfig);
    })

  }

  goToDetailPage(editRowData: any) {

  }

  cancelFieldPopup() {
    this.visibleFieldPopup.close();
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;
  auditTrail: any = {}

  openAuditTrail(viewType: any, field: any) {
    this.auditTrail.form_TemplateId_Audit_Trail = this.data.templateId;
    this.auditTrail.refNo = viewType == 'overAll' ? null : field.SECTION_ID;
    this.auditTrail.gridName = 'FORM_SECTION_TEMPLATE';
    this.auditTrail.report_And_Popup_Name = 'Forms Section Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(field);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = this.reportObj;
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = 'Forms Section Report';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, null, 0)
  }

  onChildValueEmitted() {
    this.getcallMethod();
  };

  templatesearchTxt: string = '';
  sectionSearchTxt: string = '';

  sectionDropdown: any = [];
  onFormTemplateSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.sectionDropdown = [];
      this.isProcessing = true;
      this.appService.getFormSectionTemplateList(item.templateId)
        .subscribe((data: any) => {
          this.isProcessing = false;
          this.sectionDropdown = data;
        })
    }

  }

  focusmethod(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }
}
